import { render, staticRenderFns } from "./payment-channel-mains.vue?vue&type=template&id=eb2fa4cc&"
import script from "./payment-channel-mains.vue?vue&type=script&lang=js&"
export * from "./payment-channel-mains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports